module.exports = __webpack_public_path__ + "static/media/info-lockdownload.0a2b18a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-lockdownload.png
// module id = 1750
// module chunks = 0